<i18n>
{
  "fr": {
    "Percentage": "Pourcentage",
    "ProjectsName": "Nom des projets",
    "RejectedCount": "Nombre rejetés",
    "TotalCount": "Nombre total"
  }
}
</i18n>

<template>
  <section>
    <table class="table table-bordered table-hover">
      <thead class="thead-dark">
        <tr>
          <th
            v-t="'ProjectsName'"
            scope="col"/>
          <th
            v-t="'TotalCount'"
            scope="col"/>
          <th
            v-t="'RejectedCount'"
            scope="col"/>
          <th
            v-t="'Percentage'"
            scope="col"/>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(pullRequest, index) in projectsPullRequests"
          :key="index">
          <td>{{ pullRequest.projectName }}</td>
          <td>{{ pullRequest.pullRequestCount }}</td>
          <td>{{ pullRequest.rejectedPullRequestCount }}</td>
          <td>{{ pullRequest.percentage | percentage }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('pullRequests', ['projectsPullRequests']),
  },
};
</script>
